<canvas #canvas class="hc-canvas" aria-hidden="true"></canvas>
